import { render, staticRenderFns } from "./ConfirmDialogue.vue?vue&type=template&id=0f4ef852&"
import script from "./ConfirmDialogue.vue?vue&type=script&lang=ts&"
export * from "./ConfirmDialogue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports